import { CustomActions, CustomState } from "@affinity/Store/Reducers";
import logger from "@insite/client-framework/Logger";
import { get } from "@insite/client-framework/Services/ApiService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction } from "@insite/client-framework/Store/Reducers";
import { BaseModel } from "@insite/client-framework/Types/ApiModels";

export type StrictInputDispatch = (
    action: AnyAction | ((dispatch: StrictInputDispatch, getState: () => ApplicationState) => void),
) => AnyAction;
export type customDispatch = (action: CustomActions | ((dispatch: StrictInputDispatch, getState: () => ApplicationState) => void)) => AnyAction;

class ServiceBase {
    productsUrl = "/api/v2/products";
    productsUrlOld = "/api/v1/products";
    billTosUrl = "/api/v1/billtos";
    // const realTimePricingUrl = "/api/v1/realtimepricing";
    realTimePricingUrl = "/api/v1/realtimepricing";
    orderHistory = "/api/v1/orders";
    tellAFriendUrl = "/api/v1/email/tellafriend";
    harrierPricingUrl = "/api/v1/harrierpricing";
    stripeSessionSettingsUrl = "/api/v1/stripesession/settings";

    CustomPropertyNames = {
        Product: {
            rdcoDeclarationTypeName: "rdcoDeclarationTypeName",
            maximumOrderQty: "maximumOrderQty",
        },
        Customer: {
            keroseneVatDeclaration: "keroseneVatDeclaration",
            gasOilVatDeclaration: "gasOilVatDeclaration",
            affinityKeroseneVatDeclaration: "affinityKeroseneVatDeclaration",
        },
        Orders: {
            shipTo: "shipToERP",
            pricingInfo: "pricingInfo",
        },
        CartLines: {
            isFuelProduct: "isFuelProduct",
            pricingInfo: "pricingInfo", // to access delivery by
            shipToERP: "shipToERP", // to lookup address
        },
    }

    GetCustomPropertyValue(value: BaseModel, fieldName: string) {
        // Exit if custom properties not populated
        if (Object.keys(value.properties).length === 0) {
            logger.warn("1");
            return null;
        }
        if (value.properties[fieldName] === "") {
            logger.warn("2");
            return null;
        }
        if (value.properties[fieldName] === undefined) {
            logger.warn("3");
            return null;
        }
        if (value.properties[fieldName] === "True") {
            return true;
        }
        if (value.properties[fieldName] === "False") {
            return false;
        }
    
    
        try {
            return JSON.parse(value.properties[fieldName]);
        } catch (error) {
            logger.warn(error);
            return value.properties[fieldName]
        }
    }

    getStripeSessionPublicKey() {
        return get<string>(this.stripeSessionSettingsUrl);
    }
}

export default ServiceBase;